import React, { Fragment, useEffect, useState, useContext } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

import LoadingContext from '../../context/Loading/Loading'

import { getAccessPassTemplate } from '../../utilities/api'
import { ensureWaitingRoomAccess } from '../../utilities/waitingRoom'

import { PageLoadingContainer, ViewAccessPassWrapper } from '../../components'

export default function ViewAccessPassPage() {
  const { isLoading, showLoading, hideLoading } = useContext(LoadingContext)
  const navigate = useNavigate()

  const { slug, uuid } = useParams()
  const [accessPassTemplate, setAccessPassTemplate] = useState()

  useEffect(() => {
    let redirected = false
    showLoading()
    getAccessPassTemplate(uuid)
      .then((res) => {
        const template = res?.data?.[0]
        const returnPath = `/venue/${
          slug || template?.venue?.slug
        }/access-pass/${uuid}`
        if (ensureWaitingRoomAccess(navigate, template?.events, returnPath)) {
          redirected = true
          return
        }
        setAccessPassTemplate(template)
      })
      .catch((err) => console.error(err))
      .finally(() => {
        if (!redirected) hideLoading()
      })
  }, [uuid, slug, navigate])

  return (
    <Fragment>
      <Helmet>
        <meta charSet="utf-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1"
        />
        <meta name="theme-color" content="#000000" />
        <title>{`${
          accessPassTemplate?.venue?.name || 'Venue'
        } | Access Pass`}</title>
      </Helmet>
      {isLoading ? (
        <PageLoadingContainer />
      ) : (
        <section className="background-gradient py-4 full-height">
          <ViewAccessPassWrapper accessPassTemplate={accessPassTemplate} />
        </section>
      )}
    </Fragment>
  )
}
